import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Title from '../miscellaneous/Title';
import SelectSolvers from "./SelectSolvers";
import {useStyles, types} from "../miscellaneous/constants";
import MyScatter from "./MyScatter";
import Paper from "@material-ui/core/Paper";
import clsx from "clsx";
import MyBarChart from "./MyBarChart";
import CloseIcon from '@material-ui/icons/Close';
import IconButton from "@material-ui/core/IconButton";



const myStyles = makeStyles({
    root: {
        display: "flex",
        justifyContent: "space-between"
    },
    icon: {
        position: "absolute",
        right: "10"
    },
    tooltip: {
        zIndex: 10,
        border: "1px solid lightgrey",
        backgroundColor: "white",

    },
    div: {
        padding: "5px"
    },
    name: {
        padding: "5px",
        color: "#8884d8",
        textAlign: "center",
        backgroundColor: "lightgrey"
    }
});



export default function Graphs(props) {
    const classes = useStyles();

    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

    if(props.graphSolvers == null)
        return (
            <SelectSolvers solvers={props.solvers} selectGraphSolvers={props.selectGraphSolvers} />
        )



    return (
        <React.Fragment>
            <Title><div  style={{display: "flex", justifyContent: "space-between"}}><div>{props.graphSolvers.solver1.name + " " + props.graphSolvers.solver1.version +" "}
                versus {props.graphSolvers.solver2.name + " " + props.graphSolvers.solver2.version}</div>
                <IconButton  size="small" aria-label="close" color="inherit" onClick={e => props.unselectGraphSolvers(e)}>
                    <CloseIcon  fontSize="small"/>
                </IconButton>
            </div>
            </Title>
            <Paper className={fixedHeightPaper}>
                 <MyScatter solvers={props.solvers}
                           data={props.createData(types.scatter)}
                           filters={props.filters}
                           graphSolvers={props.graphSolvers}
                />
            </Paper>
            <br />
            <br />
            <Paper  className={fixedHeightPaper}>
                <MyBarChart solvers={props.solvers}
                            data={props.createData(types.constraints)}
                            filters={props.filters}
                            graphSolvers={props.graphSolvers}
                            title="Comparison per Constraint"
                            category1_solver1={props.category1_solver1}
                            category1_solver2={props.category1_solver2}
                            category2_solver1={props.category2_solver1}
                            category2_solver2={props.category2_solver2}
                            category3_solver1={props.category3_solver1}
                            category3_solver2={props.category3_solver2}
                />
            </Paper>
            <br />
            <br />
            <Paper  className={fixedHeightPaper}>
                <MyBarChart solvers={props.solvers}
                            data={props.createData(types.families)}
                            filters={props.filters}
                            graphSolvers={props.graphSolvers}
                            title="Comparison per Problem"
                            category1_solver1={props.category1_solver1}
                            category1_solver2={props.category1_solver2}
                            category2_solver1={props.category2_solver1}
                            category2_solver2={props.category2_solver2}
                            category3_solver1={props.category3_solver1}
                            category3_solver2={props.category3_solver2}
                />
            </Paper>
        </React.Fragment>
    )
}
